<template lang="pug">
    v-card.mark-card(:height="windowHeight" :max-height="windowHeight" elevation='0').threadanalysisdrawerDialog
        template
            //- 導引列
            v-card-title.d-flex.align-center.justify-between-space.pa-0(style='border-bottom: 1px solid #E8E8E8;')
                v-col.closeBtn.pr-0(cols="auto")
                    v-btn.close-line.btn-none-effect(icon @click='onCloseDialog' tile :ripple="false")
                        v-icon(size='35') mdi-chevron-left
                v-col.d-flex.align-center.pl-0
                    span.ml-2(style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-weight: 700;") Details
                v-col(cols="auto")
                    v-btn(icon @click='onCloseDialog')
                        v-icon mdi-close
            //- 內容區
            div.pa-0.ma-0.mt-4.ml-4.pr-4.answer_area(v-if='thread_record_data')
                //- 話題列
                v-row(no-gutters)
                    v-col(cols="3")
                        label.label_title {{$t('GPT_TREADANALYSIS_DRAWER.THREAD')}}
                    v-col(cols='9')
                        label.lable_contnt {{thread_record_data.question}}
                //- 回饋列
                v-row.mt-2(no-gutters v-if ='thread_record_data.feedback')
                    v-col(cols='3')
                        label.label_title {{$t('GPT_TREADANALYSIS_DRAWER.FEEDBACK')}}
                    //- 讚
                    v-col.d-flex.align-center.justify-start(v-if='thread_record_data.feedback == "Helpful"' cols='9')
                        v-img.mb-1.mr-2(src="@/assets/images/good.svg" max-width="21px" width="21px")
                        label.lable_contnt {{$t('GPT_TREADANALYSIS_DRAWER.HELPFUL')}}
                    //- 倒讚
                    v-col.d-flex.align-center.justify-start(v-else-if='thread_record_data.feedback == "Unhelpful"' cols='9')
                        v-img.mt-1.mr-2(src="@/assets/images/bad-active.svg" max-width="21px" width="21px")
                        label.lable_contnt {{$t('GPT_TREADANALYSIS_DRAWER.UNHELPFUL')}}
                    //- 無評價
                    v-col(v-else cols='10')
                //- 相關度列
                v-row.mt-2(no-gutters)
                    v-col(cols="3")
                        label.label_title {{$t('GPT_TREADANALYSIS_DRAWER.RELEVANCE')}}
                    v-col(cols="9")
                        label.lable_contnt {{thread_record_data.relevance}}%
                //- 準確度列
                v-row.mt-2(no-gutters)
                    v-col(cols="3")
                        label.label_title {{$t('GPT_TREADANALYSIS_DRAWER.ACCURACY')}}
                    v-col(cols="9")
                        label.lable_contnt {{thread_record_data.accuracy}}%
                //- 參考列
                v-row.mt-2(no-gutters)
                    v-col(cols="3")
                        label.label_title {{$t('GPT_TREADANALYSIS_DRAWER.REFERENCES')}}
                    v-col(cols="9" v-if ='references.length > 0')
                         v-row(v-for="ref in references" :key="ref.chunk_id" no-gutters)
                            v-col(cols='1' style='margin-left: 0px; margin-top: 0px; max-width:24px')
                                v-avatar(:color='ref.color' style='height: 20px; min-width: 20px; width: 20px; font-size:14px; font-weight:400; align-content:start; ') {{ref.knowledge_lib_name[0]}}
                            v-col(cols='11' style='margin-left: 0px;').pa-0
                                label.lable_contnt(style="max-width:276px ") {{ref.filename}}
                                span.pl-0.d-flex.align-center(style='font-size:12px; font-weight:500;')
                                    v-img.pr-1(src="@/assets/images/book-mark.svg" max-width="20px" height="20px")
                                    span.ref_contnt(v-if="ref.page_num[0] !== ref.page_num[ref.page_num.length-1]" style='color: #666666;') Page {{ref.page_num[0]}}-{{ref.page_num[ref.page_num.length-1]}}
                                    span.ref_contnt(v-else style='color: #666666;') Page {{ref.page_num[0]}}
                                    span.ref_contnt.pl-1(style='color: #666666;') {{ref.title}}
                    v-col(cols="9" v-else)
                        label.lable_contnt No References
                //- 回覆列
                v-row.mt-2(no-gutters)
                    v-col(cols="3")
                        label.label_title {{$t('GPT_TREADANALYSIS_DRAWER.ANSWER')}}
                    v-col.source-type-text-content(cols="9")
                        vue-markdown(:source='String(thread_record_data.answer)')
</template>

<script>
    import Vue from 'vue';
    import VueMarkdown from 'vue-markdown-v2';
    import knowledge_color_group from "@/array/the_knowledgeColorGroup";
    export default Vue.extend({
        props: {
            checkThread: {
                type: Object,
                required: true,
            },
        },
        components: {
            VueMarkdown,
        },
        async created(){
        },

        data() {
            return{
                windowHeight: window.innerHeight,
                knowledge_color_group:knowledge_color_group,
                thread_record_data: {},
                reference_info: {},
                references: []
            }
        },
        methods: {
            addKnowledgeColor(){
                let knowledge_lib_name_list = [];
                console.log("Created " , this.thread_record_data);
                let references_list = this.thread_record_data.reference_info.references;
                let existing_ids = new Set();

                for(let i in references_list){
                    if (!existing_ids.has(references_list[i].knowledge_lib_id)) {
                        knowledge_lib_name_list.push({ id: references_list[i].knowledge_lib_id });
                        existing_ids.add(references_list[i].knowledge_lib_id);
                    }
                }
                for (let j = 0; j < knowledge_lib_name_list.length; j++) {
                    knowledge_lib_name_list[j].color = this.knowledge_color_group[j]?.color || 'aliceBlue';
                }
                for (let k in references_list) {
                    console.log("LIST", references_list[k])
                    const match = knowledge_lib_name_list.find(el => el.id === references_list[k]['knowledge_lib_id']);
                    references_list[k].color = match?.color || 'aliceBlue';
                }
            },
            onCloseDialog(){
                this.$emit("emitThreadAnalysisDrawer",false)
            },
        },
        computed: {
        },
        watch: {
            checkThread: {
                handler(newVal){
                    this.thread_record_data = newVal;
                    if (newVal) {
                      this.addKnowledgeColor();
                      this.reference_info = this.thread_record_data.reference_info
                      this.references = this.reference_info.references;
                    }
                }
            }

        },
    })
</script>
<style scoped>
.ellipsis-2 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
.label_title {
    color:#444444;
    font-weight: 500;
    font-size: 16px;
    font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;
}
.ref_contnt{
    color:#666666;
    font-weight: 400;
    font-size: 12px;
    font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;
}
.lable_contnt{
    color:#444444;
    font-weight: 400;
    font-size: 16px;
    font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;
}
.answer_area{
  max-height: 90%;
  overflow-y: auto !important;
  overflow-x: hidden;
}
.answer_area::-webkit-scrollbar {
  width: 6px; /* 調整滾動條寬度 */
}
.answer_area::-webkit-scrollbar-track {
  background:  #F4F4F4 !important;
}
.answer_area::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3) ;
  border-radius: 10px;
}
</style>